import { Quill } from "react-quill";

const Module = Quill.import('core/module');

export default class ExpandableListModule extends Module {}

